import styled from 'styled-components';

export const SingleInvoicesStyled = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
